module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-after": "always"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1__And__Page_Break",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "1.00em",
      "text-transform": "uppercase"
    }
  }, [_vm._v("WRITING")]), _vm._v(" is a solitary endeavor, but it still requires a support system, and I’m so lucky to have an ever-expanding one. My original cheering section, my husband and kids, are so patient with my spacey stares as a pesky plot point suddenly works itself out during conversations and my lies about starting dinner “as soon as I finish this paragraph.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I don’t know how I’d function without the wonderful MM community on Facebook, who provide a safe space and unending amusement. I’ve made a lot of fabulous friends over the years, but this book wouldn’t have happened without two of them, Hunter Frost and Caraway Carter. They are always there when I need them, and they unerringly know when to give me a shoulder to lean on and when to give me a kick in the ass. This book required many kicks, but I’m so glad they did because Nick and Drew were totally worth it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And lastly, a huge, huge thank-you to everyone who buys my books. You keep me going and your confidence in me means the world. Thank you.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34cb2de7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0004.vue
// module id = 66
// module chunks = 0